import Typography from "@mui/material/Typography";

import DOMPurify from "dompurify";

interface DialogParagraphProps {
  text: string;
}

const DialogParagraph = ({ text }: DialogParagraphProps) => {
  return (
    <Typography
      variant="body2Medium"
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} // this type of code allows us to escape HTML tags.
      sx={{
        marginBottom: "16px"
      }}
    />
  );
};

export default DialogParagraph;
